








import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { SimpleCard },
	setup() {
		return {};
	},
});
